import Icon from '../../../components/Icon';
import { scrollToId, scrollToNestedId } from '../../../utilities/scrollToId';

interface NavLinksProps {
  reasonsToLove: boolean;
  learningOutcomes: boolean;
  hasProductLessons: boolean;
  topTips: boolean;
}

export default function NavLinks({
  reasonsToLove,
  learningOutcomes,
  hasProductLessons,
  topTips
}: NavLinksProps) {
  return (
    <>
      <a
        className="product-details__nav-link"
        href="#descriptionTab"
        onClick={(e) => {
          e.preventDefault();
          scrollToId('descriptionTab', 'product-tab--selected');
        }}
      >
        Product Description
        <Icon iconName="chevron-right" modifierCss="product-details-nav-icon" />
      </a>
      {hasProductLessons && (
        <a
          className="product-details__nav-link"
          href="#productLessons"
          onClick={(e) => {
            e.preventDefault();
            scrollToId('productLessons', 'product-details__product-lessons');
          }}
        >
          Lessons and Lesson Resources
          <Icon
            iconName="chevron-right"
            modifierCss="product-details-nav-icon"
          />
        </a>
      )}

      {reasonsToLove && (
        <a
          className="product-details__nav-link"
          href="#reasonsToLoveLink"
          onClick={(e) => {
            e.preventDefault();
            scrollToNestedId(
              'descriptionTab',
              'product-tab--selected',
              'reasonsToLoveLink'
            );
          }}
        >
          Reasons to Love
          <Icon
            iconName="chevron-right"
            modifierCss="product-details-nav-icon"
          />
        </a>
      )}

      {learningOutcomes && (
        <a
          className="product-details__nav-link"
          href="#learningOutcomesLink"
          onClick={(e) => {
            e.preventDefault();
            scrollToNestedId(
              'descriptionTab',
              'product-tab--selected',
              'learningOutcomesLink'
            );
          }}
        >
          Learning Outcomes
          <Icon
            iconName="chevron-right"
            modifierCss="product-details-nav-icon"
          />
        </a>
      )}

      {topTips && (
        <a
          className="product-details__nav-link"
          href="#topTipsLink"
          onClick={(e) => {
            e.preventDefault();
            scrollToNestedId(
              'descriptionTab',
              'product-tab--selected',
              'topTipsLink'
            );
          }}
        >
          Top Tips
          <Icon
            iconName="chevron-right"
            modifierCss="product-details-nav-icon"
          />
        </a>
      )}
    </>
  );
}
